// B18 — global on/off switches the app UI needs (GET /api/app/flags).
//
// Until the endpoint answers — or if it fails — every flag reads as its coded
// default from shared/app-flags.ts, so a switched-off feature (Daily Pulse is
// off by default) never flashes into the navigation.

import { useQuery } from "@tanstack/react-query";
import { defaultClientAppFlags, type ClientAppFlags } from "@shared/app-flags";

export type AppFlagsState = {
  flags: ClientAppFlags;
  /** true once the endpoint has answered (success or error). */
  loaded: boolean;
};

export function useAppFlags(options: { enabled?: boolean } = {}): AppFlagsState {
  const enabled = options.enabled ?? true;
  const query = useQuery<Partial<ClientAppFlags>>({
    queryKey: ["/api/app/flags"],
    staleTime: 60_000,
    enabled,
  });
  const defaults = defaultClientAppFlags();
  const data: Partial<ClientAppFlags> =
    query.data && typeof query.data === "object" && !query.isError ? query.data : {};
  const flags: ClientAppFlags = { ...defaults };
  for (const key of Object.keys(defaults) as Array<keyof ClientAppFlags>) {
    const value = data[key];
    if (typeof value === "boolean") flags[key] = value;
  }
  return { flags, loaded: !enabled || !query.isPending };
}
